import { Fragment } from "react";
import { useSsr } from "usehooks-ts";

export default function ClientOnly({ fallback = null, children }) {
  const { isBrowser } = useSsr();
  if (!isBrowser) {
    return fallback;
  }
  return <Fragment>{children}</Fragment>;
}
